import React, { useState } from 'react';
import { Button, Modal } from 'antd';
import { ExperimentOutlined } from '@ant-design/icons';
import StructureAnalysisPage from '../../pages/structure-analysis/index';

const StructureAnalysisButton: React.FC = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      <Button 
        type="default"
        icon={<ExperimentOutlined />}
        onClick={showModal}
      >
        蛋白质结构查看
      </Button>
      
      <Modal
        title="蛋白质结构查看"
        open={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        width="95vw"
        style={{ top: 20 }}
        bodyStyle={{ 
          height: 'calc(100vh - 120px)', 
          padding: 0,
          overflow: 'auto'
        }}
      >
        <StructureAnalysisPage />
      </Modal>
    </>
  );
};

export default StructureAnalysisButton;
